<template>
	<main class="new-edit-school">
		<el-form
			:model="model"
			ref="theForm"
			label-width="100px"
			:rules="validationRules"
			@submit.native.prevent="createUpdateSchool"
		>
			<el-form-item label="名称" prop="name">
				<el-input v-model="model.name" placeholder="学校名称" />
			</el-form-item>

			<el-form-item label="所属区局" prop="bureau_id" v-if="canPickBureau">
				<el-select v-model="model.bureau_id" placeholder="请选择区局">
					<el-option v-for="item in bureausPickable" :key="item.id" :label="item.name" :value="item.id"></el-option>
				</el-select>
			</el-form-item>

			<el-form-item label="地区编码" prop="region_code">
				<el-input v-model="model.region_code" placeholder="6位数字，参见行政区划代码"></el-input>
				<div style="font-size: 12px; color: #606266; line-height: 2em; padding-left: 310px;">
					<a href="http://xzqh.mca.gov.cn/map" target="_blank">查代码</a>
				</div>
			</el-form-item>

			<el-form-item label="管理级别" prop="admin_level">
				<el-select v-model="model.admin_level" placeholder="决定能管理学校的区局">
					<el-option v-for="item in adminLevelPickable" :key="item.id" :label="item.name" :value="item.id"></el-option>
				</el-select>
			</el-form-item>

			<el-form-item v-if="canShowResetOfflineCode" label="重置离线码" prop="reset_school_code">
				<el-checkbox-group v-model="reset_school_code">
					<el-checkbox label="reset_school_code">重置</el-checkbox>
				</el-checkbox-group>
			</el-form-item>

			<el-form-item label="学段" prop="edu_parts">
				<el-checkbox-group v-model="edu_parts">
					<el-checkbox label="primary_school">小学</el-checkbox>
					<el-checkbox label="middle_school">初中</el-checkbox>
					<el-checkbox label="high_school">高中</el-checkbox>
				</el-checkbox-group>
			</el-form-item>

			<el-form-item label="学科" prop="subject">
				<el-checkbox-group v-model="subject_parts">
					<template v-for="(subject, index) in subjectPickable">
						<el-checkbox :label="subject.id" :key="index">{{ subject.name }}</el-checkbox>
					</template>
				</el-checkbox-group>
			</el-form-item>

			<el-form-item>
				<el-button v-if="$route.params.id" type="primary" native-type="submit">更新</el-button>
				<el-button v-else type="primary" native-type="submit">创建</el-button>
			</el-form-item>
		</el-form>
	</main>
</template>
<script>
export default {
	data() {
		return {
			model: {},
			reset_school_code: [],
			edu_parts: [],
			subject_parts: [],
			subjectPickable: [],
			bureausPickable: [],
			adminLevelPickable: [],
			validationRules: {
				name: [
					{
						required: true,
						message: '请输入学校名称',
						trigger: 'change'
					}
				],
				bureau_id: [
					{
						required: true,
						message: '请选择区局',
						trigger: 'change'
					}
				],
				region_code: [
					{
						required: true,
						pattern: /^[1-8][0-7]\d{4}$/,
						message: '请输入正确的地区编码',
						trigger: 'change'
					}
				],
				admin_level: [
					{
						required: true,
						message: '请选择管理级别',
						trigger: 'change'
					}
				],
				school_code: [
					{
						required: false,
						message: '请输入正确的离线码',
						trigger: 'change'
					},
					{
						validator: this.schoolCodeValidator,
						message: '离线码只能包含数字和大写字母',
						trigger: 'change'
					},
					{
						min: 8,
						max: 8,
						message: '离线码需要八位',
						trigger: 'change'
					}
				],
				edu_parts: [
					{
						validator: (rule, value, callback) => {
							if (this.edu_parts.length === 0) {
								callback(new Error('学段至少勾选一个'))
							} else {
								callback()
							}
						},
						trigger: 'change'
					}
				],
				subject: [
					{
						validator: (rule, value, callback) => {
							if (this.subject_parts.length === 0) {
								callback(new Error('学科至少勾选一个'))
							} else {
								callback()
							}
						},
						trigger: 'change'
					}
				]
			}
		}
	},
	computed: {
		canPickBureau() {
			if (this.$store.state.user.userInfo.type == this.$api.account.types.PLATFORM_ADMIN.value) {
				return true
			}

			if (this.$store.state.user.userInfo.type == this.$api.account.types.BUREAU_ADMIN.value) {
				return this.$store.state.user.userInfo.bureau_admin.bureau.admin_scope.endsWith('*') // 有多区域的
			}

			return false
		},
		canShowResetOfflineCode() {
			if (this.$route.params.id) {
				return true
			} else {
				return false
			}
		}
	},
	async created() {
		//学科列表
		let subjectRes = await this.$api.subject.list()
		this.subjectPickable = subjectRes.data
		if (this.$route.params.id) {
			// 编辑模式
			this.model = await this.$api.school.show(this.$route.params.id)

			this.$emit('breadcrumbChange', [
				{
					name: '编辑',
					to: null
				}
			])

			if (this.model.primary_school) {
				this.edu_parts.push('primary_school')
			}
			if (this.model.middle_school) {
				this.edu_parts.push('middle_school')
			}
			if (this.model.high_school) {
				this.edu_parts.push('high_school')
			}

			if (this.model.subjects.length > 0) {
				this.model.subjects.forEach(el => {
					this.subject_parts.push(el.id)
				})
			}
		} else {
			this.$emit('breadcrumbChange', [
				{
					name: '新建',
					to: null
				}
			])
		}

		if (!this.canPickBureau && this.$store.state.user.userInfo.type == this.$api.account.types.BUREAU_ADMIN.value) {
			this.model.bureau_id = this.$store.state.user.userInfo.bureau_admin.bureau_id
		}

		// 可选的区和管理等级
		let res = null
		switch (this.$store.state.user.userInfo.type) {
			case this.$api.account.types.BUREAU_ADMIN.value:
				res = await this.$api.bureau.list({
					admin_scope: this.$store.state.user.userInfo.bureau_admin.bureau.admin_scope,
					paginate: {
						size: 200
					}
				})
				this.bureausPickable = res.data

				switch (this.$store.state.user.userInfo.bureau_admin.bureau.admin_scope.length) {
					case 3:
						this.adminLevelPickable.push({ id: 0, name: '特殊直属' })
						this.adminLevelPickable.push({ id: 3, name: '省属' })
					// 故意fall
					// eslint-disable-next-line no-fallthrough
					case 5:
						this.adminLevelPickable.push({ id: 2, name: '市属' })
					// 故意fall
					// eslint-disable-next-line no-fallthrough
					case 6:
						this.adminLevelPickable.push({ id: 1, name: '区属' })
				}
				break

			case this.$api.account.types.PLATFORM_ADMIN.value:
				res = await this.$api.bureau.list({
					paginate: {
						size: 200
					}
				})
				this.bureausPickable = res.data
				this.adminLevelPickable.push({ id: 0, name: '特殊直属' })
				this.adminLevelPickable.push({ id: 3, name: '省属' })
				this.adminLevelPickable.push({ id: 2, name: '市属' })
				this.adminLevelPickable.push({ id: 1, name: '区属' })
				break
		}
	},
	methods: {
		createUpdateSchool() {
			this.$refs['theForm'].validate(async valid => {
				if (valid) {
					this.model.primary_school = false
					this.model.middle_school = false
					this.model.high_school = false

					for (var prop in this.edu_parts) {
						this.model[this.edu_parts[prop]] = true
					}

					this.model.subjects = this.subject_parts

					// school_code 为空则是重置离线码
					if (this.reset_school_code.length > 0) {
						this.model.school_code = ''
					}

					if (this.$route.params.id) {
						// 更新
						await this.$api.school.update(this.$route.params.id, this.model)
					} else {
						// 创建
						await this.$api.school.create(this.model)
					}

					// 成功后返回
					this.$router.go(-1)
				} else {
					return false
				}
			})
		},
		schoolCodeValidator(rule, value, callback) {
			const regexp = /[A-Z]|[0-9]/g
			let matched = value.match(regexp)

			if (!matched) matched = []

			if (matched?.length < value.length) {
				callback(new Error())
			} else {
				callback()
			}
		}
	}
}
</script>

<style lang="scss">
.new-edit-school {
	padding: 30px;

	.el-input {
		width: 350px;
	}

	.uploadBox {
		padding: 60px;
		color: green;
		border: 2px dashed green;
	}
}
</style>
